import { fetchData, googleTranslate } from './api_helper';

const sendMessageToBot = msg => new Promise(((resolve, reject) => {
  fetchData(`${msg.url}/WEBINTERFACE/SPEECH/api.php`, 'post', msg).then((result) => {
    resolve(result);
  }).catch((error) => {
    reject(error);
  });
}));

const translateText = text => new Promise(((resolve, reject) => {
  googleTranslate(`https://translation.googleapis.com/language/translate/v2?q=${text.query}&key=AIzaSyAvAmtWhhd592xqsr4TgbtGh9ZSuOrD-Yc&source=${text.source}&target=${text.target}`).then((result) => {
    if (text.source === 'en' && text.target === 'en') {
      resolve({
        data: {
          translations: [
            {
              translatedText: text.query
            }
          ]
        }
      });
    } else {
      resolve(result);
    }
  }).catch((error) => {
    reject(error);
  });
}));

export default {
  sendMessageToBot,
  translateText
};



// WEBPACK FOOTER //
// ./src/api/teachbot.js